import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import Divider from 'components/core/Divider/Divider'
import Icon from 'components/core/Icon/Icon'
import Tooltip from 'components/interface/Tooltip/Tooltip'
import classNames from 'lib/util/classNames'
import { useItemContext } from '../Item/context/ItemContext'
import styles from './Toggle.module.scss'

/**
 * The Accordion `Toggle`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Toggle (props) {
  const { children, className, option, useBorder } = props
  const { ariaId, isExpanded, onToggle } = useItemContext()
  const classNameOutput = useMemo(
    () => classNames([className, styles.toggle]),
    [className]
  )
  const attributes = useMemo(
    () => ({
      id: `${ariaId}-toggle`,
      'aria-expanded': isExpanded,
      'aria-controls': `${ariaId}-region`
    }),
    [className, isExpanded]
  )

  return (
    <div className={classNameOutput}>
      <Tooltip.Target
        Tag="button"
        className={styles.button}
        {...attributes}
        onClick={onToggle}
        tooltipContent={
          <Tooltip size="small">
            <Tooltip.Header>Toggle</Tooltip.Header>
          </Tooltip>
        }
      />
      <div className={styles.toggleDisplay}>
        <h1 className={styles.toggleTitle}>{children}</h1>
        <div className={styles.options}>
          {option && option}
          <Icon className={styles.toggleChevron} icon="chevron_right_b" />
        </div>
      </div>
      {useBorder && <Divider className={styles.toggleBar} />}
    </div>
  )
}

/** @type {object} */
Toggle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  useBorder: PropTypes.bool,
  option: PropTypes.node
}

Toggle.defaultProps = {
  children: null,
  className: '',
  useBorder: false,
  option: null
}

// Memoize
export default memo(Toggle)
